import React, { Component } from "react";
import Table from "../../../components/table/Table";
import { Navigate } from "react-router-dom";
import SwalServices from "../../../services/swalServices/SwalServices";
import ActionContainer from "../../../components/UIComponent/ActionTableComponent/actionContainer";
import DropdownAction from "../../../components/dropdown/DropdownAction";
import { encryptAES } from '../../../utils/Encryption';
import DropdownSelect from "../../../components/dropdown/Dropdown";
import moment from "moment";
import CONQUASMemberService from "../../../services/axiosServices/apiServices/CONQUASMemberServices";
import { getAuditContext } from "../../../utils/audit/AuthenticationLibrary";
import { CommonSuccessMessages } from "../../../utils/Messages";

export default class CONQUASRegistration extends Component {
  constructor(props) {
 
    super(props);
    this.conquasMemberService = new CONQUASMemberService();;
    this.swalServices = new SwalServices();
    this.state = {
      route: null,
      pagination: {
        pageNo: 1,
        pageSize: 10,
        orderByColumn: "",
        orderFlag: 0,
        searchText: "",
        status: 0,
        dateFrom: null,
        dateTo: null,
        filterBySource: 0,
        statusId: 0,
      },
      conquasMemberList: [],
      searchByName: "",
      searchByEmailAddress: "",
      actionDropdown: ['Update','Delete'],
      statusList: [],
    };
  }

  componentDidMount() {
    const audit = getAuditContext();

    this.getAllDropDownsForCONQUASMember();
    this.setState({ createdAppId: audit.appId, createdBy: audit.adminUserId });

  }

  getAllDropDownsForCONQUASMember = () => {
 
    this.conquasMemberService.getAllDropDownsForCONQUASMember().then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        var status = response.responseItem.responseContent.filter((drp) => drp.dropdownName === "Status");
        status.map(function (item) { delete item["dropdownName"]; return item; });
        this.setState({ statusList: status });
      }
    });
    this.getCONQUASMemberList();
  }

  getCONQUASMemberList = (pagination = this.state.pagination) => {
 
    this.setState({ isLoading: true });
    this.conquasMemberService.getCONQUASMemberList(pagination).then((response) => {
      if (response.statusCode === 200 && response.responseItem != null) {
        let data = response.responseItem.responseContent.itemList;
        data.map((x) => {                   
          x.submissionDate = x.submissionDate ? moment(x.submissionDate).format("DD MMM yyyy") : "-";

          return x;
        });
        this.setState({ conquasMemberList: data });

        this.setState({ totalResultes: response.responseItem.responseContent.totalCount });
      }
      else {
        this.swalServices.Error(response.message);
      }
      this.setState({ isLoading: false });
    })
  }
  setPagination = (newPagination) => {
    this.setState({ pagination: newPagination });
    this.getCONQUASMemberList();
  };

  searchBySubmissionDate = () => {
    this.getCONQUASMemberList(this.state.pagination);
  }

  searchByName = (value, identity) => {
    let detail = this.state.pagination;
    if (identity === "Name") {
      detail.pageNo = 1;
      detail.pageSize = 10;
      detail.searchText = value;
      this.setState({ pagination: { ...detail } });
    }
    this.getCONQUASMemberList();
  }

  setFilterParameters = (id) => {
 
    let detail = this.state.pagination;
    detail.pageNo = 1;
    detail.statusId = id;
    this.setState({ pagination: { ...detail } }, () => {
      this.getCONQUASMemberList();
    });
  }

  actions = (element, index, value) => {
 
    return element !== "conquasMemberId" ? null : (
      <>
        <ActionContainer>
          <DropdownAction
            key={index}
            index={index}
            value={value}
            options={this.state.actionDropdown}
            align="right"
            onOptionClick={this.actionClick.bind(this)}
          />
        </ActionContainer>
      </>
    );
  };

  actionClick = (index, value, option) => {
    if (value && value > 0 && option === 'Update') {
      console.log("check individual member ", value);
      this.updateSLOTSMember(value);
    }
    if (option === "Delete") {
      console.log("Delete member:", value);
      this.deleteConquasMember(value);
    }
  }
  deleteConquasMember = (value) => {
    const audit = getAuditContext();
  
    let request = {
      id: value,
      deletedBy: audit.adminUserId,
      appId: audit.appId
    };
  
    this.swalServices
      .Confirm(
        CommonSuccessMessages.Confirm_Question.replace("{0}", "Member"),
        CommonSuccessMessages.Confirm_Delete.replace("{0}", "Member"),
        CommonSuccessMessages.Yes_Text,
        CommonSuccessMessages.No_Text
      )
      .then((response) => {
  
        if (response) {
  
          this.conquasMemberService
            .deleteConquasMember(request)
            .then((response) => {
  
              if (response.statusCode === 200) {
  
                this.swalServices.Success("Deleted");
  
                // Refresh your CONQUAS member list
                this.getCONQUASMemberList();
  
              } else {
                this.swalServices.Error(response.message);
              }
  
              this.setState({ isLoading: false });
            });
        }
      });
  };

  updateSLOTSMember = (value) => {
    if (value && value > 0) {
      this.setState({ route: '/EditCONQUASMember/CONQUASMemberId?=' + encryptAES(value) });
    }
  }

  handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let detail = this.state.pagination;
    detail[name] = value;
    this.setState({ pagination: detail });
  }

  render() {
    if (this.state.route != null) {
      return <Navigate to={this.state.route} />;
    }
    return (
      <>
        <div className="main-body-section">
          <div className="bg-white px-8 pt-10 pb-12">
            <div className="grid grid-cols-12 gap-6 w-full items-center">
              <div className="2xl:col-span-2 lg:col-span-4 col-span-12">
                <h2 className="input-title mb-3">
                  {/* Search by Company */}
                  Search
                </h2>
                <div className="col-end-7 col-span-3 grid grid-cols-3 items-center">
                  <input
                    id="default"
                    className="col-span-4 text-lg h-[55px] w-full text-[#000000] border-white"
                    type="text"
                    placeholder="Search"
                    onChange={(e) => this.searchByName(e.target.value, 'Name')}
                  />
                </div>
              </div>

              <div className="2xl:col-span-3 lg:col-span-2 col-span-12">
                <h2 className="input-title mb-3">
                  Search by Status
                </h2>
                <div className="col-end-5 col-span-2 grid grid-cols-1 items-center">
                  <DropdownSelect
                    drpIdentity={"statusId"}
                    optionArray={this.state.statusList}
                    setFilterParameters={this.setFilterParameters.bind(this)}
                    value={this.state.pagination.statusId}
                  />
                </div>
              </div>

              <div className="2xl:col-span-1 lg:col-span-1 col-span-12 pt-8 text-center">
                <div className="border-l-[1px] border-[#000000] h-[48px] inline-block mx-auto"></div>
              </div>
              <div className="2xl:col-span-5 lg:col-span-6 col-span-12 pr-2">
                <h2 className="input-title mb-3">
                  Submission Date
                </h2>
                <div className="grid grid-cols-12 gap-6 items-center w-full">
                  <div className="2xl:col-span-5 lg:col-span-5 col-span-12 w-full">
                    <input
                      id="default"
                      name="dateFrom"
                      className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                      type="date"
                      value={this.state.pagination.dateFrom}
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                  <div className="2xl:col-span-1 lg:col-span-1 col-span-12 w-full text-center">
                    <h2 className="text-xl theme-color">To</h2>
                  </div>
                  <div className=" 2xl:col-span-5 lg:col-span-5 col-span-12 w-full">
                    <input
                      id="default"
                      name="dateTo"
                      className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                      type="date"
                      value={this.state.pagination.dateTo}
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                  <div className=" 2xl:col-span-1 lg:col-span-5 col-span-12 w-full conquas-registration-btn-dessign-set">
                    <button
                      className="btn btn-blue text-white font-semibold"
                      onClick={() => this.searchBySubmissionDate()}
                    >
                      <span className="text-xl text-white font-semibold tracking-normal">
                        Search
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-6 gap-4 pt-10 px-8">
            <h2 className="col-start-1 col-end-3 text-3xl font-bold text-[#000000]">
              {`Total:${this.state.totalResultes}`}
            </h2>
          </div>
          <main className="pb-10">
            <div className="w-full mx-auto">
              <div className="relative">
                <div>
                  <div className=" mt-6">
                    <Table
                      columns={[
                        { name: "Name", title: "Name" },
                        { name: "submissionDate", title: "Submission Date" },
                        { name: "email", title: "Email Address" },
                        { name: "statusName", title: "Status" },
                        { name: "conquasMemberId", title: "Action" },
                      ]}
                      pagination={this.state.pagination}
                      rows={this.state.conquasMemberList}
                      sortingColumns={["Name"]}
                      isLoading={this.state.isLoading}
                      totalResultes={this.state.totalResultes}
                      totalCount={this.state.totalResultes}
                      setPagination={this.setPagination.bind(this)}
                      customScope={[
                        {
                          column: "conquasMemberId",
                          renderTableData: this.actions.bind(this),
                        },
                      ]}
                    />
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </>
    );
  }
}